import React from 'react';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DataObjectIcon from '@mui/icons-material/DataObject';
import UmlShapeWidgetBase from './UmlShapeWidgetBase';
import UmlClassMemberTree from './UmlClassMemberTree.jsx';
import UmlClassConstructorList from './UmlClassConstructorList.jsx';
import { umlConst } from '@jxUml';
import { JxTooltip, JxTooltipRowItemDescription, JxHint, JxIconButton } from '@jx';
import { jxScrollbarThin } from '../../../JxControls/jxScrollbarStyle';
import './UmlClassWidget.css';

// Pure painter for UmlClassShape: caption (name + stereotype) + members list.

class UmlClassWidget extends UmlShapeWidgetBase {
    toggleCollapse = (e) => {
        e.stopPropagation();
        const shape = this.props.shape;
        this.props.onShapeCollapseToggled?.(shape.id, !shape.collapsed);
    };

    getMinSize() {
        const shape = this.props.shape;
        const distinctVisibilities = new Set(
            shape.members.map(function getVisibility(member) {
                return member.visibility;
            }),
        ).size;
        return {
            width: Math.max(140, shape.caption.text.length * 8 + 40),
            // height: 56 + shape.members.length * 22 + distinctVisibilities * 20,
            height: umlConst.CLASS_COLLAPSED_HEADER_HEIGHT,
        };
    }

    getEditableZoneClassName() {
        return 'uml-class-widget-name';
    }

    getEditableInputClassName() {
        return 'uml-class-widget-name-input';
    }

    getEditableText() {
        return this.props.shape.caption.text;
    }

    render() {
        const shape = this.props.shape;
        const collapsed = shape.collapsed;
        const isOrphanedWhileDragging = this.props.draggingShapeIdRef?.current === shape.id && !shape.parentId;
        const captionZone = shape.description ? (
            <JxHint title={shape.description}>{this.renderEditableZone(shape.caption.text)}</JxHint>
        ) : (
            this.renderEditableZone(shape.caption.text)
        );
        return (
            <JxTooltip followCursor title={<JxTooltipRowItemDescription label="Press D" value="Delete shape" />}>
                <div
                    className={`uml-class-widget${this.props.isSelected ? ' uml-selected' : ''}${collapsed ? ' uml-class-widget--collapsed' : ''}${isOrphanedWhileDragging ? ' uml-class-widget--orphaned-while-dragging' : ''}`}
                    data-shape-id={shape.id}
                    style={{
                        left: shape.x,
                        top: shape.y,
                        width: shape.w,
                        height: collapsed ? undefined : shape.h,
                        zIndex: this.props.stackIndex ?? shape.zIndex,
                    }}
                    onMouseDown={this.handleDragMouseDown}
                >
                    <div className="uml-class-widget-header">
                        <DataObjectIcon sx={{ fontSize: 12 }} className="uml-class-widget-type-icon" />
                        <div className="uml-class-widget-header-text">
                            {captionZone}
                            {shape.caption.stereotype && (
                                <div className="uml-class-widget-stereotype">&lt;&lt;{shape.caption.stereotype}&gt;&gt;</div>
                            )}
                        </div>
                        <JxIconButton
                            className="uml-class-widget-collapse-toggle"
                            icon={collapsed ? <ExpandMoreIcon sx={{ fontSize: 15 }} /> : <ExpandLessIcon sx={{ fontSize: 15 }} />}
                            onMouseDown={(e) => e.stopPropagation()}
                            onClick={this.toggleCollapse}
                            title={collapsed ? 'Expand' : 'Collapse'}
                        />
                    </div>
                    {!collapsed && <UmlClassConstructorList members={shape.members} />}
                    {!collapsed && (
                        <div className={`uml-class-widget-members ${jxScrollbarThin}`}>
                            <UmlClassMemberTree members={shape.members} />
                        </div>
                    )}
                    {!collapsed && this.renderResizeHandles()}
                </div>
            </JxTooltip>
        );
    }
}

export default UmlClassWidget;
